namespace TabAurous.HR {
    export interface LeavePolicyRow {
        LeavePolicyId?: number;
        LeavePolicyCode?: string;
        LeaveTypes?: LeavePolicyDetailsRow[];
    }

    export namespace LeavePolicyRow {
        export const idProperty = 'LeavePolicyId';
        export const nameProperty = 'LeavePolicyCode';
        export const localTextPrefix = 'HR.LeavePolicy';
        export const deletePermission = 'HR:LeavePolicy:Delete';
        export const insertPermission = 'HR:LeavePolicy:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:LeavePolicy:Edit';

        export declare const enum Fields {
            LeavePolicyId = "LeavePolicyId",
            LeavePolicyCode = "LeavePolicyCode",
            LeaveTypes = "LeaveTypes"
        }
    }
}
